package com.cybersoftsolution.cybersoftsolutionweb.components.toast

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun MyToastContainer(
    padding: Int = 16,
    position: ToastPosition = ToastPosition.BottomRight,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
){
    Div(
        attrs = Modifier
            .then(modifier)

            .padding(all = padding.px)
            .classNames("toast-container", "position-fixed" ,*position.classes.toTypedArray())
            .styleModifier {
                property("pointer-events", "none")
            }
//            .fillMaxSize()
//            .backgroundColor(Theme.HalfBlack.rgb)
            .toAttrs()
    ){
        content()
    }

}



enum class ToastPosition(val classes: List<String>) {
    TopLeft(classes = listOf("top-0", "start-0")),
    TopCenter(classes = listOf("top-0", "start-50")),
    TopRight(classes = listOf("top-0", "end-0")),
    CenterLeft(classes = listOf("top-50", "start-0", "translate-middle-y")),
    Center(classes = listOf("top-50", "start-50", "translate-middle")),
    CenterRight(classes = listOf("top-50", "end-0", "translate-middle-y")),
    BottomLeft(classes = listOf("bottom-0", "start-0")),
    BottomCenter(classes = listOf("bottom-0", "start-50", "translate-middle-x")),
    BottomRight(classes = listOf("bottom-0", "end-0","p-3"))
}

//@Composable
//fun example(){
//    Div(
//        attrs = Modifier
//            .padding(all = 16.px)
//            .classNames("toast-container", *listOf("position-fixed","bottom-0", "end-0","p-3").toTypedArray())
//            .styleModifier {
//                property("pointer-events", "none")
//            }
//            .toAttrs()
//    ){
//        Div(
//            attrs = Modifier
//                .id(toastBasicID)
//                .zIndex(9)
//                .classNames("toast",  "border-0")
//                .styleModifier {
//                    property("pointer-events", "auto")
//                }
//                .toAttrs {
//                    attr("role", "alert")
//                    attr("aria-live", "assertive")
//                    attr("aria-atomic", "true")
//                    attr("data-bs-autohide", "true")
//                }
//        ) {
//            Row(
//                modifier = Modifier.classNames("toast-body"),
//                horizontalArrangement = Arrangement.SpaceBetween
//            ) {
//                SpanText(text = "text")
//                BSCloseButton(
//                    modifier = Modifier
//                        .onClick {
//
//                        }
//                        .attrsModifier {
//                            attr("data-bs-dismiss", "toast")
//                        },
//                    dark = false
//                )
//            }
//        }
//    }
//
//
//}